var _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTshirt1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 176,
    viewBox: "0 0 176 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3281_2158",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 73,
    width: 80,
    height: 74
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.3359 73.6853H127.653V146.097H48.3359V73.6853Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3281_2158)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.909 74.0722C120.495 74.0722 118.513 76.054 118.513 78.4685V133.52C118.513 135.61 116.784 137.267 114.658 137.267H61.2635C59.1369 137.267 57.408 135.573 57.408 133.52V78.4685C57.408 76.054 55.4262 74.0722 53.0117 74.0722C50.599 74.0722 48.6172 76.054 48.6172 78.4685V133.52C48.6172 140.437 54.3097 146.058 61.2635 146.058H114.658C121.648 146.058 127.304 140.437 127.304 133.52V78.4685C127.304 76.0173 125.359 74.0722 122.909 74.0722Z",
    fill: "#FEC000"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M153.102 88.7003C147.158 51.2655 137.502 40.9255 136.42 39.8805C135.988 39.4478 135.484 39.1233 134.908 38.9088C134.259 38.6558 118.514 32.747 110.803 30.6222C108.462 29.9732 106.048 31.3427 105.4 33.6838C105.364 33.8287 105.327 34.0083 105.327 34.1513C105.111 34.6573 105.003 35.1963 105.003 35.7738C104.715 37.7905 97.7609 45.5382 87.9617 45.5382C78.1974 45.5382 71.2087 37.7905 70.9557 35.8453C70.9557 35.3045 70.8475 34.7655 70.6679 34.2595C70.6312 34.045 70.6312 33.8635 70.5597 33.6472C69.9107 31.306 67.498 29.9365 65.155 30.5855C57.4459 32.7103 41.7012 38.6192 41.0522 38.8722C40.4747 39.0885 39.9705 39.413 39.5379 39.8457C38.458 40.8888 28.8019 51.2307 22.8564 88.6637C22.497 91.0067 24.0462 93.2397 26.424 93.6723L37.9539 95.7972C38.205 95.8338 38.4947 95.8705 38.7459 95.8705C40.8359 95.8705 42.6729 94.3928 43.0689 92.2662C43.5015 89.8883 41.9157 87.5838 39.5379 87.1512L32.2962 85.8183C36.9804 59.2277 43.5015 49.0673 45.267 46.7262C48.2572 45.6097 56.9399 42.4032 63.4262 40.3132C66.7409 46.9792 76.5052 54.329 88.0332 54.329C99.563 54.329 109.362 46.9792 112.642 40.3132C119.163 42.4032 127.846 45.6097 130.836 46.7262C132.638 49.0673 139.086 59.048 143.77 85.8183L137.214 87.0063C134.835 87.439 133.251 89.7453 133.683 92.1232C134.079 94.248 135.916 95.7257 138.006 95.7257C138.257 95.7257 138.547 95.689 138.798 95.6542L149.644 93.6723C151.914 93.3112 153.498 91.0782 153.102 88.7003Z",
    fill: "#FEC000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTshirt1);
export default __webpack_public_path__ + "static/media/tshirt_1.8383e3bbaec7b8000091c79d12d53530.svg";
export { ForwardRef as ReactComponent };